import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { FONT_VARIANT } from "../../../../components/fonts/font-props";

interface IProps {
    notCharged: boolean;
    value: string;
}

const ChargedAmount: React.FC<IProps> = ({ notCharged, value }) => {
    if (notCharged) {
        return <FontBody2 variant={FONT_VARIANT.LINE_TROUGH}>{value}</FontBody2>
    }
    return <FontBody2>{value}</FontBody2>
};

export default ChargedAmount;
